import { ESTOQUE_BACKEND_URL } from "../settings";
import { api } from "./api";

class ProductShelfLifeService {
  constructor() {
    this.url = ESTOQUE_BACKEND_URL;
  }

  async list(params) {
    const url = `${this.url}/api/blueberry/v1/warehouse/product-base/shelf-life`;
    return await api.get(url, { params });
  }

  async getByProductBaseId(productBaseId) {
    const url = `${this.url}/api/blueberry/v1/warehouse/product-base/${productBaseId}/shelf-life`;
    return await api.get(url);
  }

  async save(productBaseId, data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/product-base/${productBaseId}/shelf-life`;
    return await api.put(url, data);
  }
}

const productShelfLifeService = new ProductShelfLifeService();
export default productShelfLifeService;
